import { motion } from "framer-motion";
import { ANNOUNCE } from "@/constants/testIds";
import { ANNOUNCEMENTS } from "@/data/anabiya";

export const AnnouncementBar = () => {
  return (
    <div
      data-testid={ANNOUNCE.root}
      className="relative bg-forest text-white/90 overflow-hidden h-9 flex items-center"
    >
      <motion.div
        data-testid={ANNOUNCE.track}
        className="flex whitespace-nowrap items-center gap-16 pr-16"
        animate={{ x: ["0%", "-50%"] }}
        transition={{ duration: 34, ease: "linear", repeat: Infinity }}
      >
        {[...ANNOUNCEMENTS, ...ANNOUNCEMENTS, ...ANNOUNCEMENTS].map((t, i) => (
          <span key={i} className="flex items-center gap-16 overline">
            <span>{t}</span>
            <span className="text-gold">✦</span>
          </span>
        ))}
      </motion.div>
    </div>
  );
};
